import { css } from '@emotion/core'
import parse from 'html-react-parser'
import * as React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { ButtonBlock } from './ctas/CTAMain'
import Image from './Image'

interface HubspotSubmittedBlockProps {
  submittedMessage?: string
  submittedImage?: React.ReactNode
}

const HubspotSubmittedBlock: React.FunctionComponent<HubspotSubmittedBlockProps> = ({
  submittedMessage = 'Your confirmation email with the access link is on its way. <br className="hide-on-small hide-on-large" /> Check your inbox! <div className="footnote center">(It might be hiding in your spam/promotions folder.)</div>',
}) => {
  return (
    <div css={submittedContainerStyle}>
      <div className="strong-body-1 center">{parse(submittedMessage)}</div>
      <div css={submittedImageStyle}>
        <Image src="abstract/hubspot-submit.webp" alt="airfocus form submit envelope" />
      </div>
      <div className="strong-body-1 center">Experience the new way of doing product management</div>
      <ButtonBlock withoutGhostButton />
    </div>
  )
}

export default HubspotSubmittedBlock

const submittedContainerStyle = css`
  text-align: center;
  margin: auto 0;
  background: rgba(173, 230, 255, 0.22);
  padding: 2rem 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .button-block {
    margin-top: 1rem;
  }

  @media screen and (max-width: ${breakpoints.large}px) {
    padding: 1.5rem 1rem;
  }

  @media screen and (max-width: ${breakpoints.medium}px) {
    padding: 1.5rem 2rem 2rem;
    margin: 1rem auto;
    max-width: 31.25rem;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    align-items: stretch;
  }
`

const submittedImageStyle = css`
  min-width: 7rem;
  width: 34%;
  max-width: 10rem;
  margin: 1rem auto;
`
